import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "./routes"
import { useAuthStore } from "@/stores/auth"

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes, /* eslint-disable */
  scrollBehavior(to, from, savedPosition) {
   
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
   
   
  },
})
// nasna
router.beforeEach(async (to, from, next) => {
  if (to.fullPath.includes("?phoneNumber=")) {
    // Extract package name from path (e.g., /auth/check/weekly)
    let packageMatch = to.path.match(/\/check\/(\w+)/);
    let packageName = packageMatch ? packageMatch[1] : "daily";
    let user_id = to.query.user_id;
    return next({
      name: 'subscribe_ok',
      params: {
        package: packageName,
        phoneNumber: to.query.phoneNumber,
        user_id: user_id
      }
    });
  }

  const user = localStorage.getItem("user");

  if (to.name === 'subscribe_ok') {
    const phone = to.params.phoneNumber;
    const packageName = to.params.package;
    const user_id = to.params.user_id;

    const auth = useAuthStore();
    await auth.checkSubescriptionStatus(phone, packageName, user_id);
    return next();
  }

  if (to.meta.auth && user === null) {
    return next({ name: 'subscribe.header' });
  }

  if (to.meta.auth && user !== null) {
    return next();
  }

  if (to.meta.auth === false) {
    return next();
  }

  next();
});



export default router